module.exports = __webpack_public_path__ + "img/download_icon_email@3x.625709a9.png";